<div class="dropzone">
  <input type="file" #inputFileSelection multiple="false" [formControl]="fc" (change)="fileBrowseHandler($event.target.files)" />

  <h3 translate>send_sms_recipients_drag</h3>
  <span [hidden]="hideFormat" style="margin-bottom: 10px;" translate>{{ formatLabel }}</span>

  <div [hidden]="hideDownload" style="position: inherit; z-index: 3; margin-bottom: 10px;">
    <a style="color: #067337;" [href]="'import_contacts_model_download_link' | translate" target="_blank">
      <span translate>send_sms_recipients_drag_model_download</span>
    </a>
  </div>
  <div style="margin-bottom: 10px;">
    <span translate>send_sms_recipients_drag_or</span>
  </div>

  <wsb-atlas-button
    (btnClick)="openFileSelecion()"
    class="custom-button-z-index"
    label="send_sms_recipients_drag_browsefile"
  ></wsb-atlas-button>

  <div>
    {{ fileSelected?.name }}
  </div>
</div>

<div *ngIf="errorMsg" class="invalid-feedback d-block">
  {{ errorMsg }}
</div>
